import { openGallery } from '../vendor/fancybox';
import autoResizeTextarea from './components/auto-resize-textarea';
import bootstrapModal from './components/bootstrap-modal';
import customCalendar from './components/calendar';
import customCarousel from './components/carousel';
import customSelect from './components/custom-select';
import datePicker from './components/date-picker';
import delayedRedirect from './components/delayed-redirect';
import favouriteButton from './components/favourite-button';
import hashHighlight from './components/hash-highlight';
import hyperPayWidget from './components/hyperpay';
import imageUpload from './components/image-upload';
import locationPicker from './components/location-picker';
import otpInput from './components/otp-input';
import pageLoader from './components/page-loader';
import phoneInput from './components/phone-input';
import providerPage from './components/provider-page';
import reviewComment from './components/review-comment';
import uiModal from './components/ui-modal';

/**
 * Reusable `x-data` scopes. Each name maps to one module in ./components, so a Blade view
 * only needs `x-data="name({ ...config })"`.
 */
const components = {
    autoResizeTextarea,
    bootstrapModal,
    customCalendar,
    customCarousel,
    customSelect,
    datePicker,
    delayedRedirect,
    favouriteButton,
    hashHighlight,
    hyperPayWidget,
    imageUpload,
    locationPicker,
    otpInput,
    pageLoader,
    phoneInput,
    providerPage,
    reviewComment,
    uiModal,
};

/**
 * Registers every component and magic on Alpine. Must run before `Livewire.start()`.
 *
 * @param {import('alpinejs').Alpine} Alpine
 */
export function registerAlpine(Alpine) {
    Object.entries(components).forEach(([name, component]) => Alpine.data(name, component));

    // $gallery('gallery-12', 0) opens the Fancybox lightbox for a data-fancybox group.
    Alpine.magic('gallery', () => openGallery);
}
